import { createStore } from 'satcheljs';
import GroupOptionsViewState from './schema/GroupOptionsViewState';

export default createStore<GroupOptionsViewState>('GroupsOptionStore', {
    echoGroupMessageBackToSubscribedSender: null,
});
